module.exports = __webpack_public_path__ + "img/list_komisi.442dc581.png";